import {
	Sidebar,
	SidebarContent,
	SidebarFooter,
	SidebarHeader,
	SidebarRail,
} from '@/components/ui/sidebar';
import { cn } from '@/lib/utils';
import { mainMenu } from './menuItems';
import { NavMain } from './NavMain';
import { NavUser } from './NavUser';
import { TeamSwitcher } from './TeamSwitcher';

export default function AppSidebar({
	className,
	...props
}: React.ComponentProps<typeof Sidebar>) {
	return (
		<Sidebar
			className={cn('bg-[#FAFAFA] h-svh', className)}
			collapsible="icon"
			{...props}
		>
			<SidebarHeader>
				<TeamSwitcher />
			</SidebarHeader>
			<SidebarContent>
				<NavMain items={mainMenu} />
			</SidebarContent>
			<SidebarFooter>
				<NavUser />
			</SidebarFooter>
			<SidebarRail />
		</Sidebar>
	);
}
